module.exports = __webpack_public_path__ + "img/horizontal_6_5_pp2_8003.26934c80.png";